import { render, staticRenderFns } from "./passPie.vue?vue&type=template&id=6ed3bf82&scoped=true&"
import script from "./passPie.vue?vue&type=script&lang=js&"
export * from "./passPie.vue?vue&type=script&lang=js&"
import style0 from "./passPie.vue?vue&type=style&index=0&id=6ed3bf82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed3bf82",
  null
  
)

export default component.exports